import React, { Component } from 'react'
import Md5 from 'md5'

import Header from 'components/Header';

import Paths from 'paths'

class Login extends Component{

    componentDidMount() {
        this.password.focus(); 
    }

    handleSubmit = (e) => {
        e.preventDefault()
        if(this.password.value === process.env.REACT_APP_LOGIN_PW) {
            sessionStorage.setItem("logged-hash", Md5(process.env.REACT_APP_LOGIN_PW));
            this.props.history.push(this.props.location.state.pathname !== Paths.PATH_ADMIN_LOGIN ? this.props.location.state.pathname : Paths.PATH_ADMIN_HOME);
        }
    }

    render(){
        return (
            <section id="la-soundbox-container" className={'home'}>
                <Header />
                <form id={'soundbox-login'} onSubmit={(e) => this.handleSubmit(e)}>
                    <input id="login-password" name="login-password" type="password" ref={input => this.password = input} required/>
                    <button type="submit">OK</button>
                </form>
            </section>
        )
    }
}

export default Login
